import { IconButton } from '@ps/isp-web-component-library';
import { Trash } from '@ps/isp-web-component-library/icons/Trash';
import React from 'react';
import { useFormState } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import type { Dispatch } from '@swf/core/store';
import { select } from '@swf/core/store';

import { TXTWCL_Clear_Bets } from './ClearBetSlipButton.messages.json';

const ClearBetSlipButton: React.FC = () => {
  const { formatMessage } = useRegulatoryIntl();
  const hasSelections = useSelector(select.betSlip.hasSelections);
  const { submitting: isSubmitting } = useFormState<FormData>({
    subscription: { submitting: true }
  });
  const dispatch = useDispatch<Dispatch>();

  return (
    <IconButton
      onClick={() => dispatch.betSlip.selectionsCleared()}
      variant="outline"
      disabled={isSubmitting || !hasSelections}
      label={formatMessage(TXTWCL_Clear_Bets)}
      icon={Trash}
      size="medium"
    />
  );
};

export default ClearBetSlipButton;
